import { render, staticRenderFns } from "./TrainingItemBlocks.vue?vue&type=template&id=7923d8d0&"
import script from "./TrainingItemBlocks.vue?vue&type=script&lang=js&"
export * from "./TrainingItemBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports